import React from 'react';
import { IListingState } from './sellFormReducer';
import { CompletionStatus, ISellFormViewData } from './SellFormView';

export interface ISellFormContext {
  formState: IListingState;
  dispatch: React.Dispatch<any>;
  onNavigationClick: (targetSection) => void;
  onSubmit: (targetSection) => void;
  nextSection: string;
  previousSection: string;
  sellFormViewData?: ISellFormViewData;
  loading?: boolean;
  completionStatusMap: { string?: CompletionStatus };
  errorMap: Record<string, string>;
  setIsSubmitting?: React.Dispatch<React.SetStateAction<boolean>>;
  isDraft?: boolean;
  showBumpModal?: boolean;
  setShowBumpModal?: React.Dispatch<React.SetStateAction<boolean>>;
  listingCreateFlow?: boolean;
  showRequiredFieldError?: boolean;
  setShowRequiredFieldError?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SellFormContext = React.createContext<ISellFormContext>({
  formState: null,
  dispatch: () => {},
  onNavigationClick: () => {},
  onSubmit: () => {},
  nextSection: null,
  previousSection: null,
  sellFormViewData: { me: {}, countries: {} },
  loading: false,
  completionStatusMap: {},
  errorMap: {},
  setIsSubmitting: () => {},
  isDraft: false,
  showBumpModal: false,
  setShowBumpModal: () => {},
  listingCreateFlow: true,
  showRequiredFieldError: false,
  setShowRequiredFieldError: () => {},
});
